const rouConfig = [
  {
    path: 'maintenance',
    name: 'maintenance',
    meta: {
      name: '菜品维护',
    },
    component: () => import('./maintenance')
  },
 

];

export default rouConfig;